module.exports = __webpack_public_path__ + "static/media/helpcard_shopping.f8e36ee3.svg";